import { useEffect, useState } from 'react'
import { nothing } from '$helper/functions/utils'
import { useAsyncFunction } from '$func/async-function.react-hook'
import {
  getAppNewReleases,
  needForceUpdateTwa,
} from '$logic/client-device/service'
import { saveReleaseVersion } from '$logic/client-device/storage'
import { isInTwa, twaVersion } from '$func/environmentInfo'

export function useGetChangelog() {
  const { value: changeLog, loading } = useAsyncFunction(getAppNewReleases, [])
  const onClose = async () => {
    if (!changeLog?.[0]?.version) return
    await saveReleaseVersion(changeLog[0].date, changeLog[0].version)
  }
  return {
    loadMore: () => nothing,
    items: loading ? [] : changeLog,
    hasFinished: true,
    loading,
    onClose,
  }
}

export function useNeedForceUpdateTwa() {
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    setIsOpen(needForceUpdateTwa)
  }, [isInTwa, twaVersion])
  return isOpen
}
